<app-header></app-header>

<div class="not-found-container">
  <h1 class="error-code">404</h1>
  <p class="error-text">Oops! The page you're looking for doesn't exist.</p>
</div>
